import { render, staticRenderFns } from "./PeopleBarCharttool.vue?vue&type=template&id=0b11f9c6"
import script from "./PeopleBarCharttool.vue?vue&type=script&lang=js"
export * from "./PeopleBarCharttool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports